import {Component} from '@angular/core';
import {FormBuilder, FormGroup, Validators} from "@angular/forms";
import {HttpClient, HttpStatusCode} from "@angular/common/http";
import {LoaderService} from "../../../../services/loader/loader.service";
import {ActivatedRoute} from "@angular/router";
import {RestResponse} from "../../../../Interfaces/RestResponse.interface";
import RestHelper from "../../../../Helper/RestHelper";
import {User} from "../../../../Interfaces/user.interface";
import {Customer} from "../../../../Interfaces/customer.interface";

@Component({
  selector: 'app-userform',
  templateUrl: './userform.component.html',
  styleUrl: './userform.component.css'
})
export class UserformComponent {

  public userform: FormGroup = this.formBuilder.group({
    username: ["", [Validators.required, Validators.minLength(4)]],
    name: ["", [Validators.required, Validators.minLength(4)]],
    lastname: ["", [Validators.required, Validators.minLength(4)]],
    customer: [""],
    permissions: [[]],
  })
  public sentstatus: number = 0

  public operation: string | undefined
  public uuid: string | undefined

  public user: User | undefined
  public permissions: string[] | undefined
  public customers: Customer[] | undefined

  public apierror: boolean = false

  constructor(private httpClient: HttpClient, private formBuilder: FormBuilder, protected loader: LoaderService, private route: ActivatedRoute) {
    this.loader.showLoader()

    this.route.params.subscribe(params => {
      this.operation = params['operation']
      this.uuid = params['uuid']
    });

    this.httpClient.get<RestResponse<Customer[]>>(RestHelper.API_BASE_URL + "customer/getCustomer", RestHelper.requestOptions).subscribe({
      next: (value) => {
        this.customers = value.data
      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })

    this.httpClient.get<RestResponse<string[]>>(RestHelper.API_BASE_URL + "getPermissions", RestHelper.requestOptions).subscribe({
      next: (value) => {
        this.permissions = value.data
      }, error: () => {
        this.apierror = true
        this.loader.hideLoader()
      }
    })


    if (this.operation === "edit" || this.operation === "delete") {
      if (this.uuid === undefined) {
        //TODO Error UUID ist benötigt wenn create, update oder delete
        return
      }

      this.httpClient.get<RestResponse<User>>(RestHelper.API_BASE_URL + "user/getUser?uuid=" + this.uuid, RestHelper.requestOptions).subscribe({
        next: (value) => {
          console.log(value.data)

          this.user = value.data

          console.log(this.user)

          this.getFormControls()['username'].setValue(this.user.username)
          this.getFormControls()['name'].setValue(this.user.name)
          this.getFormControls()['lastname'].setValue(this.user.lastname)
          this.getFormControls()['permissions'].setValue(this.user.permissions)

          if (this.operation === "delete") {
            this.userform.disable()
          }

          this.loader.hideLoader()
          this.apierror = false
        }, error: () => {
          this.apierror = true
          this.loader.hideLoader()
        }
      })
    } else {
      this.loader.hideLoader()
    }
  }

  public getOperation(): string {
    switch (this.operation) {
      case "create":
        return "Erstellen"
      case "edit":
        return "Bearbeiten"
      case "delete":
        return "Löschen"
    }
    return ""
  }

  public onSubmit() {
    if (!this.userform.valid) {
      this.userform.markAllAsTouched()
      for (let el in this.userform.controls) {
        if (this.userform.controls[el].errors) {
          console.log(el)
        }
      }
      console.log("Form Invalid")
      return;
    }

    const body = new FormData();
    body.append("username", this.userform.value.username)
    body.append("name", this.userform.value.name)
    body.append("lastname", this.userform.value.lastname)

    body.append("permissions", this.userform.value.permissions)

    console.log("Permissions: " + this.userform.value.permissions)

    if (this.operation === "edit") {
      body.append("uuid", String(this.uuid))
    }
    if (this.operation === "create") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'user/createUser', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
            this.userform.reset()
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    } else if (this.operation === "edit") {

      this.httpClient.post(RestHelper.API_BASE_URL + 'user/updateUser', body, RestHelper.requestOptions)
        .subscribe({
          next: () => {
            this.sentstatus = 1
          },
          error: (err) => {
            this.sentstatus = err.status === HttpStatusCode.TooManyRequests ? 3 : 2
            console.error(err)
          }
        });
    }
  }

  public getFormControls() {
    return this.userform.controls;
  }

  protected readonly console = console;
}
